import React, { useState, useEffect } from 'react';

import TextField from '@material-ui/core/TextField';
import Modal from 'components/Tvendo/Common/ModalBase';
import Autocomplete from '@material-ui/lab/Autocomplete';
import moment from 'moment';
import { WithApp } from 'contexts/appContext';
import { wsGetAll } from 'services/WService.js';
import { ImportExcel } from 'components/Tvendo/Common/ImportExcel';
import { FormControl, InputLabel, MenuItem, Select } from '@material-ui/core';
import { wsFindBy } from 'services/WService';

export default WithApp(function ModalCuotaSupervisor(props) {
  const cuota = props.model;
  const [dataChanging, setDataChanging] = useState([]);
  const [zones, setZones] = useState([]);
  const [bureau, setBureau] = useState([]);
  const [portfolio, setPortfolio] = useState([]);
  const [seller, setSellers] = useState([]);
  const [providers, setProviders] = useState([]);
  const [marks, setMarks] = useState([]);
  const [providerMarks, setProviderMarks] = useState([]);
  const [dataExcel, setDataExcel] = useState(undefined);
  const [dataImport, setDataImport] = useState({});

  function handleChange(field, value) {
    setDataChanging(prev => ({ ...prev, [field]: value }));
  }

  async function listZones() {
    let response = await wsGetAll('base/zone');
    if (response.success) setZones(response.data);
  }
  async function listBureau(zoneId) {
    let response = await wsFindBy('base/bureau', {base_zone_id: zoneId, state: 'A', delete_at: null});
    if (response.success) setBureau(response.data);
  }

  async function listPortfolio(zoneId) {
    let response = await wsFindBy('base/customer-portfolio', {base_zone_id: zoneId, state: 'A', delete_at: null});
    if (response.success) setPortfolio(response.data);
  }

  async function listSeller(portfolioId, bureauId) {
    let response = await wsFindBy('quota/seller-portfolio', {base_customer_portfolio_id: portfolioId, base_bureau_id: bureauId});
    if (response.success) setSellers(response.data);
  }

  async function listProviderMarks() {
    let response = await wsGetAll('logi/provider-marks');
    if (response.success) {
      setProviderMarks(response.data);

      const uniqueProviders = [];
      const seen = new Set();
      response.data.forEach(item => {
        if (!seen.has(item.base_business_partner_id)) {
          seen.add(item.base_business_partner_id);
          uniqueProviders.push({
            id: item.base_business_partner_id,
            CardCode: item.CardCode,
            CardName: item.CardName,
          });
        }
      });
      setProviders(uniqueProviders);
    }
  }

  function handleProviderChange(providerId) {
    handleChange('base_business_partner_id', providerId);

    const filteredMarks = providerMarks
      .filter(pm => String(pm.base_business_partner_id) === String(providerId))
      .map(pm => ({
        id: pm.logi_mark_id,
        description: pm.logi_mark_description,
      }));

    setMarks(filteredMarks);
  }


  useEffect(() => {
    if (cuota.open) {
      setDataChanging([]);
      listZones();
      listProviderMarks();
    }
    setDataExcel(undefined);
  }, [cuota.open]);

  useEffect(() => {
    if (dataChanging.base_zone_id !== null && dataChanging.base_zone_id !== undefined ) {
      listBureau(dataChanging.base_zone_id);
      listPortfolio(dataChanging.base_zone_id);
    }
  }, [dataChanging.base_zone_id]);
  useEffect(() => {
    if (dataChanging.base_customer_portfolio_id !== null && dataChanging.base_customer_portfolio_id !== undefined && 
        dataChanging.base_bureau_id !== null && dataChanging.base_bureau_id !== undefined ) {
      listSeller(dataChanging.base_customer_portfolio_id, dataChanging.base_bureau_id);
    }
  }, [dataChanging.base_customer_portfolio_id,dataChanging.base_bureau_id]);

  useEffect(() => {
    if (zones.length > 0 && cuota.base_zone_id) {
      handleChange("base_zone_id", String(cuota.base_zone_id));
    }
  },[zones]);
  useEffect(() => {
    if (bureau.length > 0 && cuota.base_bureau_id) {
      handleChange("base_bureau_id", String(cuota.base_bureau_id));
    }
  },[bureau]);
  useEffect(() => {
    if (portfolio.length > 0 && cuota.base_customer_portfolio_id) {
      handleChange("base_customer_portfolio_id", String(cuota.base_customer_portfolio_id));
    }
  },[portfolio]);
  useEffect(() => {
    if (seller.length > 0 && cuota.base_seller_id) {
      handleChange("base_seller_id", String(cuota.base_seller_id));
    }
  },[seller]);

  useEffect(() => {
    if (providers.length > 0 && cuota.base_business_partner_id) {
      handleProviderChange(String(cuota.base_business_partner_id));
    }
  }, [providers]);

  useEffect(() => {
    if (marks.length > 0 && cuota.logi_mark_id) {
      handleChange("logi_mark_id", String(cuota.logi_mark_id));
    }
  }, [marks]);


  useEffect(() => {
    if (dataImport?.success) {
      console.log("Importación exitosa", dataImport);
  
      setDataChanging((prev) => ({
        ...prev,
        base_zone_id: null,
      }));
  
      setDataExcel({
        success: dataImport.success,
        cuota: dataImport.data.map((item) => {
          return {
            base_zone_code: item.SEDE,
            CardCode: item.PROVEEDOR,
            logi_mark_code: item.MARCA.toString(),
            base_portfolio_code: item.CARTERA.toString(),
            base_seller_code: item.VENDEDOR,
            base_bureau_code: item.MESA.toString(),
            cuota: item.CUOTA,
          };
        }),
      });
    } else if (dataImport?.success === false) {
      console.log("Importación fallida", dataImport);
      setDataExcel(undefined);
    }
  }, [dataImport]);

  return (
    <>
      <Modal
        title={`Nueva Cuota`}
        model={ cuota }
        setOpen={props.setOpen}
        showNotify={props.showNotify}
        reload={props.reload}
        arrDataResponse
        state
        entity={
          dataExcel?.success
            ? 'quota/quota-group/multiple'
            : 'quota/quota-group'
        }
        dataForce={
          dataExcel?.success
            ? {
                cuota: dataExcel?.cuota,
              }
            : {
                base_zone_id: dataChanging.base_zone_id,
                base_bureau_id: dataChanging.base_bureau_id,
                base_customer_portfolio_id: dataChanging.base_customer_portfolio_id,
                base_seller_id: dataChanging.base_seller_id,
                base_business_partner_id: dataChanging.base_business_partner_id,
                logi_mark_id: dataChanging.logi_mark_id,
              }
        }
      >
        <TextField
          label="Periodo"
          fullWidth
          type="month"
          name="Periodo"
          margin="normal"
          defaultValue={moment(cuota.valueSearch?.Periodo).format('YYYY-MM') || ''}
          InputLabelProps={{ shrink: true }}
          inputProps={{ readOnly: true }}
          required
        />
        <span style={{ display: 'flex', alignItems: 'flex-end' }}>
          <Autocomplete
            disableClearable
            options={zones}
            getOptionLabel={(item) => `${item.description}`}
            renderInput={(params) => (
              <TextField {...params} label="Sede" margin="normal" fullWidth />
            )}
            onChange={(e, item) => {handleChange('base_zone_id', item?.id);setDataImport(null);}}
            value={zones.find((zone) => String(zone.id) === String(dataChanging.base_zone_id)) || null }
            style={{ flexGrow: 1, marginRight: '10px' }}
          />
          <ImportExcel
            setDataImport={setDataImport}
            btnColor="success"
            validDuplicate={['SEDE','MESA','CARTERA','PROVEEDOR','VENDEDOR','MARCA']}
            sortDuplicate={['SEDE','MESA','CARTERA','PROVEEDOR','MARCA']}
            downTemplate={{
              fileNameDown: `${moment(cuota?.valueSearch?.Periodo).format('YYYY-MM')}_Plantilla de cuota`,
              fields: ['SEDE','MESA','CARTERA','PROVEEDOR','VENDEDOR','MARCA','CUOTA']
            }}
          />
        </span>
        {dataImport?.success && (
          <p style={{ color: '#07c107', marginTop: '10px', fontSize: '14px' }}>
            Archivo importado: {dataImport.nameFile}
          </p>
        )}
        {dataChanging.base_zone_id ? (
          <>
            <Autocomplete
              disableClearable
              options={bureau}
              getOptionLabel={(item) => `${item.description}`}
              renderInput={(params) => (
                <TextField {...params} label="Mesa" margin="normal" fullWidth />
              )}
              onChange={(e, item) => { handleChange('base_bureau_id', item?.id);}}
              value={bureau.find((b) => String(b.id) === String(dataChanging.base_bureau_id)) || null}
              style={{ flexGrow: 1, marginRight: '10px' }}
            />
            <Autocomplete
              disableClearable
              options={portfolio}
              getOptionLabel={(item) => `${item.description}`}
              renderInput={(params) => (
                <TextField {...params} label="Cartera" margin="normal" fullWidth />
              )}
              onChange={(e, item) => { handleChange('base_customer_portfolio_id', item?.id);}}
              value={portfolio.find((p) => String(p.id) === String(dataChanging.base_customer_portfolio_id)) || null}
              style={{ flexGrow: 1, marginRight: '10px' }}
            />
            <Autocomplete
              disableClearable
              options={seller}
              getOptionLabel={(item) => `${item.SlpName} (Código: ${item.SlpCode})`}
              renderInput={(params) => (
                <TextField {...params} label="Vendedor" margin="normal" fullWidth />
              )}
              onChange={(e, item) => { handleChange('base_seller_id', item?.id);}}
              value={seller.find((s) => String(s.id) === String(dataChanging.base_seller_id)) || null}
              style={{ flexGrow: 1, marginRight: '10px' }}
            />
            <Autocomplete
              disableClearable
              options={providers}
              getOptionLabel={(item) => `${item.CardName} (Código: ${item.CardCode})`}
              renderInput={(params) => (
                <TextField {...params} label="Proveedor" margin="normal" fullWidth />
              )}
              onChange={(e, item) => handleProviderChange(item?.id)}
              value={providers.find((p) => String(p.id) === String(dataChanging.base_business_partner_id)) || null}
              style={{ flexGrow: 1, marginRight: '10px' }}
            />

            <Autocomplete
              disableClearable
              options={marks}
              getOptionLabel={(item) => item.description}
              renderInput={(params) => (
                <TextField {...params} label="Marca" margin="normal" fullWidth />
              )}
              onChange={(e, item) => handleChange('logi_mark_id', item?.id)}
              value={marks.find((m) => String(m.id) === String(dataChanging.logi_mark_id)) || null}
              style={{ flexGrow: 1, marginRight: '10px' }}
            />

            <TextField
              label="Cuota"
              fullWidth
              type="number"
              name="cuota"
              margin="normal"
              defaultValue={!!cuota ? cuota.cuota : ''}
              onChange={(e) => handleChange('cuota', e.target.value)}
              required
            />
          </>
        ) : undefined}
      </Modal>
    </>
  );
});

